import { makeStyles } from "@material-ui/core/styles";

export const useSizeFieldsStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  fieldWrapper: {
    margin: "25px 25px 0 0",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    display: "inline-block",
    marginTop: "5px",
  },
}));
